// extracted by mini-css-extract-plugin
module.exports = {"styledBlockquote":"ptWcnOJg","textWrapper":"dB0J1uhz"};